// extracted by mini-css-extract-plugin
export default {"block":"block___FWO0F","text_left":"text_left___WOq0G","text_right":"text_right___CjBVz","text":"text___SLSyK","lg":"lg____AI6C","reverse":"reverse___lZbSQ"};